(function() {
  var Router,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  exports.MapsUploadRouter = (function(superClass) {
    extend(MapsUploadRouter, superClass);

    function MapsUploadRouter() {
      return MapsUploadRouter.__super__.constructor.apply(this, arguments);
    }

    MapsUploadRouter.prototype.prefix = 'MapsUpload';

    MapsUploadRouter.prototype.module_name = 'MapsUploadRouter';

    MapsUploadRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.module.filter('typeFilter', function() {
        return function(collection, text) {
          var i, len, list, type, type_name;
          if (text === '') {
            return collection;
          }
          list = [];
          text = text.toLowerCase();
          for (i = 0, len = collection.length; i < len; i++) {
            type = collection[i];
            if (typeof type === 'object') {
              type_name = type.name.toLowerCase();
            } else {
              type_name = type.toLowerCase();
            }
            if (type_name.indexOf(text) !== -1) {
              list.push(type);
            }
          }
          return list;
        };
      });
      this.module.filter('yearFilter', function() {
        return function(collection, text) {
          var i, len, list, year;
          if (text === '') {
            return collection;
          }
          list = [];
          for (i = 0, len = collection.length; i < len; i++) {
            year = collection[i];
            year = year.toString();
            if (year.indexOf(text) !== -1) {
              list.push(year);
            }
          }
          return list;
        };
      });
      this.service('grower::Angular/Data/Add/Maps/Upload/Services/MapsUploadService', ['$http', '$uibModal', 'MapsUpload.Services.TypeHelpService']);
      this.service('grower::Angular/Data/Add/Maps/Upload/Services/TypeHelpService');
      this.service('grower::Angular/Data/Add/Maps/Upload/Conversion/Services/DataManagementService', ['$http', '$rootScope']);
      this.service('grower::Angular/Data/Add/Maps/Upload/Conversion/Services/MapsConversionMatrixService', ['$http']);
      this.controller('grower::Angular/Data/Add/Maps/Upload/DialogController', ['$scope', '$transitions', '$state', 'MapsUpload.Services.MapsUploadService', '$uibModalInstance', '$window', '$transition$']);
      this.controller('grower::Angular/Data/Add/Maps/Upload/DuplicateFileDialogController', ['$state', '$transitions', '$scope', '$uibModalInstance', 'MapsUpload.Services.MapsUploadService', 'data', '$window', '$rootScope']);
      this.controller('grower::Angular/Data/Add/Maps/Upload/InvalidShapefileDialogController', ['$state', '$scope', '$transitions', '$uibModalInstance', 'data']);
      this.controller('grower::Angular/Data/Add/Maps/Upload/Conversion/StatusController', ['$scope', '$transitions', '$state', '$uibModal', 'Data.Services.MapsConversionService', 'Core.Services.Loading']);
      this.controller('grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationController', ['$scope', '$transitions', '$state', 'MapsUpload.Services.MapsConversionMatrixService', '$window', '$timeout']);
      this.controller('grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationYieldController', ['$scope', '$transitions', '$state', 'MapsUpload.Services.MapsConversionMatrixService', 'MapsUpload.Services.DataManagementService', 'Core.Services.Loading', '$window', '$uibModal']);
      this.controller('grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationPlantingController', ['$scope', '$transitions', '$state', 'MapsUpload.Services.MapsConversionMatrixService', 'MapsUpload.Services.DataManagementService', 'Core.Services.Loading', '$window', '$uibModal']);
      this.controller('grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationManagementZoneController', ['$scope', '$transitions', '$state', 'MapsUpload.Services.MapsConversionMatrixService', 'MapsUpload.Services.DataManagementService', 'Core.Services.Loading', '$window']);
      return this.controller('grower::Angular/Data/Add/Maps/Upload/Conversion/IngredionDialogController', ['$state', '$scope', '$transitions', '$uibModalInstance', '$http', 'survey']);
    };

    MapsUploadRouter.prototype.registerRoutes = function($stateProvider) {};

    return MapsUploadRouter;

  })(Router);

}).call(this);
